if (document.getElementById('vue-account')) {
	Vue.use(VeeValidate);
	new Vue({
		delimiters: ['[[', ']]'],
		mixins: [baseMixin, eventHubMixin, headerMixin, languageMixin, apiMixin],
		el: '#vue-account',
		data: {
			filters: {
				partners: {
					options: [],
					model: {}
				}
			},
			residentId: null,
			record: {},
			user: {},
			displayConfirm: false,
			showMore: false,
			isShortLived: false,
			notifications: [],
		},
		created() { },
		mounted() {
			if (window.hasOwnProperty('token')) {
				localStorage.setItem('token', window.token);
				this.setUser();
			}
			this.user = JSON.parse(localStorage.getItem('user'));
			this.getRecords();
			const urlParams = new URLSearchParams(window.location.search)
			this.isShortLived = urlParams.has('short-lived');
			if (sync_accounting_failed) {
				this.notifications.push({
					notification: gettext("La dernière synchronisation avec Scepia ne s'est pas déroulée correctement. Cela peut se traduire par un montant incorrect de votre solde.")
				})
				this.notifications.forEach((el) => {
					this.eventHub.$emit('notifications:error', {
						notification: el.notification
					});
				});
			}
		},
		computed: {},
		methods: {
			getRecords() {
				this.get('residents/' + this.user.id + '/application')
					.then((response) => {
						this.record = response.data;
					})
					.catch((error) => {
						// console.log(error);
					});
			},
			setUser() {
				this.get('users/me').then((response) => {
					localStorage.setItem('user', JSON.stringify(response.data));
				});
			},
			deleteRecord() {
				this.patch('residents/' + this.user.id + '/cancel-application')
					.then((response) => {
						this.displayConfirm = false;
						this.getRecords();
						// console.log(response);
					})
					.catch((error) => {
						this.displayConfirm = false;
						// console.log(error);
					});
			}
		}
	});
}
